export default __webpack_public_path__ + "static/media/graph_placeholder_1.6f3a6842.png";